export const useConvertTokenToPDFText = (
  token: ParagraphToken,
  alignment: string,
  lineHeight: number
) => {
  let tokenText = {
    text: token.text == "\u000b" || token.text.includes("\n") ? "" : token.text,
    ...useConvertTokenToPDFFormatting(token.formatting, alignment, lineHeight),
  };

  return tokenText;
};
